export default __webpack_public_path__ + "static/media/background1.4b3d6e6b.svg";